import type { RunningHubJobClientMeta } from '../utils/applyRunningHubJobRecovery';
import { api } from "./apiClient";

function isDataImageUrl(input: string): boolean {
  return /^data:image\/(png|jpeg|jpg|webp|gif);base64,/i.test(input || '');
}

async function normalizeUpscaleInputImage(image: string): Promise<string> {
  if (isDataImageUrl(image)) return image;
  // 历史记录/远程结果常是 http(s) URL，后端放大接口仅接受 base64，这里先走后端代理转 dataURL
  if (/^https?:\/\//i.test(image)) {
    const resp = await api.fetchImageDataUrl(image);
    // 后端 /api/gemini/fetch-image 返回 { dataUrl, contentType }
    const dataUrl = (resp as any)?.dataUrl || (resp as any)?.base64;
    if (typeof dataUrl === 'string' && isDataImageUrl(dataUrl)) return dataUrl;
    throw new Error('图片URL转换失败：未拿到有效的 base64 数据');
  }
  throw new Error('图片格式无效：请使用 base64 图片或可访问的 http(s) 图片链接');
}

export const upscaleImage = async (
  base64Image: string,
  scaleValue: number,
  onProgress: (desc: string) => void,
  userEmail?: string,
  jobMeta?: RunningHubJobClientMeta,
): Promise<{ url: string; remainingCredits?: number; historyArchived?: boolean; clientItemId?: string }> => {
  onProgress('正在准备图片...');

  try {
    const normalizedImage = await normalizeUpscaleInputImage(base64Image);
    onProgress('正在提交放大任务...');
    const response = (await api.upscaleImage(normalizedImage, scaleValue, userEmail, jobMeta)) as {
      url: string;
      remainingCredits?: number;
      historyArchived?: boolean;
      clientItemId?: string;
    };
    onProgress('放大完成！');
    return {
      url: response.url,
      remainingCredits: response.remainingCredits,
      historyArchived: response.historyArchived,
      clientItemId: response.clientItemId,
    };
  } catch (error: any) {
    onProgress('放大失败');
    throw error;
  }
};